import { Injectable } from '@angular/core';

declare var gtag;

@Injectable({
  providedIn: 'root',
})
export class SettingsAnalyticsService {
  constructor() {}

  analyticSettingVisited() {
    gtag('event', 'setting_visited', {
      event_category: 'Setting Events',
    });
  }

  analyticSettingNameChanged() {
    gtag('event', 'setting_name_changed', {
      event_category: 'Setting Events',
    });
  }

  analyticSettingGenderChanged() {
    gtag('event', 'setting_gender_changed', {
      event_category: 'Setting Events',
    });
  }

  analyticSettingBirthdayChanged() {
    gtag('event', 'setting_birthday_changed', {
      event_category: 'Setting Events',
    });
  }

  analyticSettingWeightChanged() {
    gtag('event', 'setting_weight_changed', {
      event_category: 'Setting Events',
    });
  }

  analyticSettingHeightChanged() {
    gtag('event', 'setting_height_changed', {
      event_category: 'Setting Events',
    });
  }

  analyticSettingAboutUsVisited() {
    gtag('event', 'setting_about_us_visited', {
      event_category: 'Setting Events',
    });
  }

  analyticSettingLogoutCompleted() {
    gtag('event', 'setting_logout_completed', {
      event_category: 'Setting Events',
    });
  }
}
